import { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { SideDrawer } from 'vopay';

import { withStyles } from 'vopay';
import styles from './ContactDetailDrawer.module.scss';
import ContactDetailView, { ContactDetailViewProps } from './ContactDetailView';

import { Button } from '#shared/components/UI';

const cn = withStyles(styles);

export type ContactDetailDrawerProps = Omit<ContactDetailViewProps, 'clientAccountId'> & {
  // The row's linked record; the drawer is open while set.
  clientAccountId?: string;
  onClose: () => void;
};

// Full-screen drawer around the read-only contact detail view. Non-modal so
// plain-Modal dialogs opened from the embedded accounting tabs stay
// interactive.
export default function ContactDetailDrawer({
  clientAccountId,
  clientAccountsEnabled,
  accounting,
  onClose,
}: ContactDetailDrawerProps): JSX.Element {
  const { t } = useTranslation('translations', { keyPrefix: 'Shared.Contacts.Drawer' });
  const { t: tShared } = useTranslation('translations', { keyPrefix: 'Shared' });

  return (
    <SideDrawer
      isOpen={!!clientAccountId}
      onClose={onClose}
      title={
        clientAccountsEnabled
          ? t('clientTitle', { defaultValue: 'Client Details' })
          : t('contactTitle', { defaultValue: 'Contact Details' })
      }
      modal={false}
      style={{ width: '100vw' }}
      footerClassName={cn('footer')}
      footer={
        <Button colorScheme="secondary" onClick={onClose}>
          {tShared('Buttons.close', { defaultValue: 'Close' })}
        </Button>
      }
    >
      {clientAccountId && (
        <ContactDetailView
          clientAccountId={clientAccountId}
          clientAccountsEnabled={clientAccountsEnabled}
          accounting={accounting}
        />
      )}
    </SideDrawer>
  );
}
